import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", lastLineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${lineClassName} ${i === lines.length - 1 ? lastLineClassName : ""}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.13, ease: EASE }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <p
    className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] ${
      dark ? "text-gold" : "text-gold"
    } ${className}`}
  >
    {children}
  </p>
);

export const SectionHead = ({ num, eyebrow, title, dark = false, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-baseline gap-4 mb-6">
      {num && (
        <span className="font-mono text-xs text-gold tracking-[0.25em]" data-testid={`section-num-${num}`}>
          {num}
        </span>
      )}
      <span className="h-px w-10 bg-gold/60" />
      <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
    </div>
    <h2
      className={`font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight ${
        dark ? "text-cream" : "text-ink"
      }`}
    >
      {title}
    </h2>
  </Reveal>
);

export const PageHero = ({ eyebrow, lines, sub, dark = false, children }) => (
  <section
    className={`pt-32 lg:pt-44 pb-14 lg:pb-20 px-6 sm:px-12 lg:px-20 ${
      dark ? "bg-ink text-cream" : "bg-cream text-ink"
    }`}
  >
    <motion.p
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: EASE }}
      className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-gold mb-6"
    >
      {eyebrow}
    </motion.p>
    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl">
      <MaskedLines lines={lines} delay={0.1} />
    </h1>
    {sub && (
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.5, ease: EASE }}
        className={`mt-7 max-w-xl text-base leading-relaxed ${dark ? "text-cream/70" : "text-ink/70"}`}
      >
        {sub}
      </motion.p>
    )}
    {children}
  </section>
);
